import { loadState, saveState } from './persistence';

let state = loadState();
let config = null;

export function initGameLogic(loadedConfig) {
  config = loadedConfig;
}

export function getState() {
  return state;
}

export function gainXP(amount) {
  state.xp += amount;
  const xpForNextLevel = getXPForNextLevel(state.level);
  if (state.xp >= xpForNextLevel) {
    levelUp();
  }
  saveState(state);
}

function levelUp() {
  state.level += 1;
  state.skillPoints += 1;
  state.xp = 0;
  unlockAchievements('level', state.level);
}

function getXPForNextLevel(level) {
  return 100 * level; // Simple linear scaling, can be config-driven
}

export function unlockSkill(skillId) {
  if (state.skillPoints <= 0) return false;
  if (state.unlockedSkills.includes(skillId)) return false;

  state.unlockedSkills.push(skillId);
  state.skillPoints -= 1;
  saveState(state);
  unlockAchievements('skill', skillId);
  return true;
}

function unlockAchievements(type, value) {
  // Placeholder: Add achievement logic
  // e.g., if level >= 10, add "Veteran" achievement
  // or if skillId === 'some_special_skill', add "Specialist"
}

export function resetGame() {
  state = loadState();
}